import React, { useEffect, useState } from 'react'

import {
  Tooltip, message, Button, Badge, Table, Spin, Modal, Space, PageHeader, Divider,
} from 'antd'

import { format } from 'date-fns'

import {
  EditOutlined, DeleteOutlined, CaretRightOutlined, PlusOutlined,
} from '@ant-design/icons'

import { fetch } from '../../utils/fetch'

import ManageJobModal from '../component/ManageJobModal.js'

const { Column } = Table

const Job = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [jobData, setJobData] = useState([])
  const [statusDb, setStatusDb] = useState(false)
  const [editItem, setEditItem] = useState(null)
  const [visible, setVisible] = useState(false)

  useEffect(
    () => { getJob(); getStatusDbC3d() }, [])

  const getJob = () => {
    setIsLoading(true)
    fetch({
      url: '/management/job',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.data?.success) {
        setJobData(res.data?.data)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const getStatusDbC3d = () => {
    setIsLoading(true)
    fetch({
      url: '/management/c3d/status',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.data?.success) {
        setStatusDb(res.data?.success)
      } else {
        setStatusDb(res.data?.success)
        // message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const forceRun = (id, name) => {
    setIsLoading(true)
    fetch({
      url: `/management/job/${id}/run`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      console.log(res)
      if (res.data?.success) {
        message.success(`${name} is running`)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const removeCfg = (id) => {
    setIsLoading(true)
    fetch({
      method: 'DELETE',
      url: `/management/job/${id}`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.data?.success) {
        message.success(res.data.message)
        getJob()
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const showConfirmRemove = (id) => {
    const { confirm } = Modal
    confirm({
      title: 'Confirm Remove',
      content: 'Are you sure to remove this config?',
      okText: 'Yes',
      okButtonProps: {
        text: 'Yes',
      },
      cancelButtonProps: {
        cancelText: 'No',
      },
      onOk() {
        removeCfg(id)
      },
    })
  }

  const showConfirmRun = (id, name) => {
    const { confirm } = Modal
    confirm({
      title: 'Confirm Run Immediately  ',
      content: 'Are you sure to run this job immediately?',
      okText: 'Yes',
      okButtonProps: {
        text: 'Yes',
      },
      cancelButtonProps: {
        cancelText: 'No',
      },
      onOk() {
        forceRun(id, name)
      },
    })
  }

  const onSuccess = () => {
    setVisible(false)
    setEditItem(null)
    getJob()
  }

  const onCancel = () => {
    setVisible(false)
    setEditItem(null)
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <ManageJobModal
          visible={visible}
          editItem={editItem}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
        <PageHeader
          ghost={false}
          title="Job"
          extra={(
            <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditItem(null); setVisible(true) }}>New</Button>
          )}
        >
          <Divider />
          <div>

            <Button onClick={getStatusDbC3d}>
              <Badge
                status={statusDb ? 'success' : 'error'}
                // status="processing"
                // color={!statusDb ? 'green' : 'red'}
                size="default"
              />
              C3D DB Status
            </Button>
          </div>

          <br />
          <Table
            dataSource={jobData}
            size="small"
          >
            <Column title="Cfg Id" dataIndex="cfgJobId" key="cfgJobId" width={50} align="center" sorter={(a, b) => a.cfgJobId - b.cfgJobId} sortDirections={['ascend']} />
            <Column title="Name" dataIndex="funcName" key="funcName" width={100} ellipsis />
            <Column title="Cron" dataIndex="cron" key="cron" width={80} />
            <Column title="Status" dataIndex="isActive" key="isActive" width={50} align="center" render={(text) => (text ? <Badge status="success" /> : <Badge status="error" />)} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            <Column title="Updated At" dataIndex="updatedAt" key="updatedAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            <Column
              title="Action"
              key="action"
              fixed="right"
              align="center"
              width={120}
              render={(text, record) => (
                <Space size="middle">
                  <Tooltip title="Run job immediately">
                    <Button
                      icon={(<CaretRightOutlined />)}
                      shape="circle"
                      onClick={() => { showConfirmRun(record.cfgJobId, record.funcName) }}
                    />
                  </Tooltip>
                  <Tooltip title="Edit job config">
                    <Button
                      icon={(<EditOutlined />)}
                      shape="circle"
                      onClick={() => {
                        setEditItem(record)
                        setVisible(true)
                      }}
                    />
                  </Tooltip>
                  <Tooltip title="Romove job config">
                    <Button
                      icon={(<DeleteOutlined />)}
                      shape="circle"
                      onClick={() => { showConfirmRemove(record.cfgJobId) }}
                    />
                  </Tooltip>
                </Space>
              )}
            />
          </Table>
        </PageHeader>
      </Spin>
    </>
  )
}

export default Job
